
import React, { useEffect, useState } from 'react';
import ReactConfetti from 'react-confetti';

interface ConfettiEffectProps {
  duration?: number;
  sourcePosition?: {
    x: number;
    y: number;
    width?: number;
    height?: number;
  };
}

const ConfettiEffect: React.FC<ConfettiEffectProps> = ({ 
  duration = 3000,
  sourcePosition
}) => {
  const [dimensions, setDimensions] = useState({ 
    width: window.innerWidth,
    height: window.innerHeight 
  });
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);

    // Set a timer to hide the confetti after the specified duration
    const timer = setTimeout(() => {
      setIsActive(false);
    }, duration);

    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timer);
    };
  }, [duration]);

  if (!isActive) return null;

  // If no source position is provided, use a default centered position
  const confettiSource = sourcePosition ? {
    x: sourcePosition.x,
    y: sourcePosition.y,
    w: sourcePosition.width || 100,
    h: sourcePosition.height || 0
  } : {
    x: dimensions.width / 2,
    y: 0,
    w: dimensions.width,
    h: 0
  };

  return (
    <div className="fixed inset-0 pointer-events-none z-50">
      <ReactConfetti
        width={dimensions.width}
        height={dimensions.height}
        recycle={false}
        numberOfPieces={150}
        gravity={0.25}
        colors={[
          '#FFC0CB', // Pink
          '#9b87f5', // Primary purple
          '#7E69AB', // Secondary purple
          '#FFD700', // Gold
          '#87CEFA', // Light sky blue
          '#98FB98', // Pale green
          '#FF6B6B', // Coral red
          '#FFD166', // Amber
        ]}
        confettiSource={confettiSource}
        tweenDuration={duration}
        initialVelocityY={5}
        initialVelocityX={sourcePosition ? 2 : 0}
        // Removed the unsupported 'angle' property
      />
    </div>
  );
};

export default ConfettiEffect;
